export const productIds = {
  sticks: 1139,
};
